import amplitude from 'amplitude-js';
import { AMPLITUDE_KEY } from 'config';

class amplitudeService {
  constructor() {
    this.isInit = false;
  }

  init = () => {
    amplitude.getInstance().init(AMPLITUDE_KEY);
    this.isInit = true;
  };

  track = (name, properties = {}, callback) => {
    if (!this.isInit) this.init();
    amplitude.getInstance().logEvent(name, properties, callback);
  };

  // 充電樁資訊頁
  entryPageView = ({ serialNumber, evseId, evseName, storeName }) =>
    this.track('充電樁資訊頁_pageview', {
      充電樁代碼: serialNumber,
      充電樁ID: evseId,
      充電樁名稱: evseName,
      充電站名稱: storeName,
    });
  entryHowToUseOnClick = ({ serialNumber, evseId, evseName, storeName, state }) =>
    this.track('充電樁資訊頁-如何使用_點擊', {
      充電樁代碼: serialNumber,
      充電樁ID: evseId,
      充電樁名稱: evseName,
      充電站名稱: storeName,
      充電樁狀態: state,
    });
  entryAuthorizationOnClick = ({ serialNumber, evseId, evseName, storeName, state }) =>
    this.track('充電樁資訊頁-連鎖店授權_點擊', {
      充電樁代碼: serialNumber,
      充電樁ID: evseId,
      充電樁名稱: evseName,
      充電站名稱: storeName,
      充電樁狀態: state,
    });
  entryTermsOnClick = () => this.track('充電樁資訊頁-服務條款_點擊');
  entryPrivacyOnClick = () => this.track('充電樁資訊頁-隱私權政策_點擊');

  // 使用說明頁
  instructionsPageView = () => this.track('使用說明頁_pageview');
  instructionsOnClose = () => this.track('使用說明頁-關閉_點擊');

  // 載入前往付款頁
  loadingPaymentPageView = () => this.track('載入前往付款頁_pageview');

  // 錯誤頁
  errorPageView = ({ serialNumber, errorCode, text, error }) => {
    this.track('錯誤頁_pageview', {
      充電樁代碼: serialNumber,
      錯誤代碼: errorCode,
      錯誤標題: text,
      error: error,
    });
  };

  errorReauthorizeOnClick = ({ serialNumber, errorCode, text }) =>
    this.track('錯誤頁-返回重新授權_點擊', {
      充電樁代碼: serialNumber,
      錯誤代碼: errorCode,
      錯誤標題: text,
    });

  // 充電啟動載入頁
  chargingLoadingPageView = () => this.track('充電啟動載入頁_pageview');

  // 提示充電槍連結頁
  chargingPlugHintPageView = () => this.track('提示充電槍連結頁_pageview');
  chargingPlugRetryButtonOnClick = ({ serialNumber, evseId, evseName, email }) =>
    this.track('提示充電槍連結頁-重新連線_點擊', {
      充電樁代碼: serialNumber,
      車主信箱: email,
    });

  // 查看充電中頁_pageview
  chargingPageView = ({ serialNumber, accTime, startTime, currentTime, watt, amount, state, stopReason }) =>
    this.track('查看充電中頁_pageview', {
      充電樁代碼: serialNumber,
      累計充電時間: accTime,
      開始時間: startTime,
      目前時間: currentTime,
      充電瓦數: watt,
      預計費用: amount,
      狀態: state,
    });

  chargingNavigationOnClick = ({ serialNumber, evseId, evseName, email }) =>
    this.track('查看充電中頁-導航前往取車_點擊', {
      充電樁代碼: serialNumber,
      充電樁ID: evseId,
      充電樁名稱: evseName,
      車主信箱: email,
    });

  // 提示充電完成頁
  chargingCompletePageView = ({ serialNumber, evseId, evseName, accTime, startTime, currentTime, watt, amount }) =>
    this.track('提示充電完成頁_pageview', {
      充電樁代碼: serialNumber,
      充電樁ID: evseId,
      充電樁名稱: evseName,
      累計充電時間: accTime,
      開始時間: startTime,
      目前時間: currentTime,
      充電瓦數: watt,
      預計費用: amount,
    });
  chargingCompleteModifyEmailOnClick = ({ serialNumber, evseId, evseName, email }) =>
    this.track('提示充電完成頁-開啟修改信箱_點擊', {
      充電樁代碼: serialNumber,
      充電樁ID: evseId,
      充電樁名稱: evseName,
      車主信箱: email,
    });
  chargingCompleteConfirmEmailOnClick = ({ serialNumber, evseId, evseName, email }) =>
    this.track('提示充電完成頁_確認修改信箱_點擊', {
      充電樁代碼: serialNumber,
      充電樁ID: evseId,
      充電樁名稱: evseName,
      車主信箱: email,
    });
  chargingCompleteNavigationOnClick = ({ serialNumber, evseId, evseName, email }) =>
    this.track('提示充電完成頁-導航前往取車_點擊', {
      充電樁代碼: serialNumber,
      充電樁ID: evseId,
      充電樁名稱: evseName,
      車主信箱: email,
    });

  chargingStoppedPageView = ({ serialNumber, accTime, startTime, currentTime, watt, amount, stopReason, state }) =>
    this.track('充電結束頁_pageview', {
      充電樁代碼: serialNumber,
      累計充電時間: accTime,
      開始時間: startTime,
      目前時間: currentTime,
      充電瓦數: watt,
      預計費用: amount,
      停止原因: stopReason,
      狀態: state,
    });

  serviceEndedPageView = ({
    serialNumber,
    accTime,
    startTime,
    currentTime,
    watt,
    amount,
    idleFee,
    refundAmount,
    chargingFee,
    stopReason,
    state,
  }) =>
    this.track('充電完成頁_pageview', {
      充電樁代碼: serialNumber,
      累計充電時間: accTime,
      開始時間: startTime,
      目前時間: currentTime,
      充電瓦數: watt,
      充電費用: chargingFee,
      超時佔位費: idleFee,
      應付款金額: amount,
      退還授權金額: refundAmount,
      停止原因: stopReason,
      狀態: state,
    });

  // 入口頁接上充電樁提示
  plugGuidanceModalOpen = ({ serialNumber }) => this.track('接上充電槍視窗_開啟', { 充電樁代碼: serialNumber });
  plugGuidanceModalButtonOnClick = () => this.track('接上充電槍視窗_充電槍已插好_點擊');

  // 提示充電槍連結頁-未插槍 120s 連線逾時
  chargingTimeoutPageView = ({ state, stopReason }) =>
    this.track('已結束充電-連線逾時_pageview', { 狀態: state, 停止原因: stopReason });
  chargingTimeoutButtonOnClick = ({ state, stopReason }) =>
    this.track('已結束充電-連線逾時_我知道了_點擊', { 狀態: state, 停止原因: stopReason });

  // 查看充電中頁-輸入聯繫資訊_pageview
  chargingContactInputPageView = ({ phone, email }) =>
    this.track('查看充電中頁-輸入聯繫資訊_pageview', {
      車主手機: phone,
      車主信箱: email,
    });

  // 查看充電中頁-輸入聯繫資訊
  chargingContactInputSendOnClick = ({ phone, email }) =>
    this.track('查看充電中頁-輸入聯繫資訊_寄送通知_點擊', {
      車主手機: phone,
      車主信箱: email,
    });

  chargingContactInputResendButtonOnClick = () => this.track('查看充電中頁-聯繫資訊寄送失敗_重新送出_點擊');
  chargingContactInputCloseButtonOnClick = () => this.track('查看充電中頁-聯繫資訊寄送失敗_關閉視窗_點擊');
  chargingContactInputIconCloseButtonOnClick = () => this.track('查看充電中頁-聯繫資訊寄送失敗_右上角X符號_點擊');

  // 查看充電中頁_停止充電_點擊
  chargingPageStopChargingOnClick = ({ state, stopReason }) =>
    this.track('查看充電中頁_停止充電_點擊', { 狀態: state, 停止原因: stopReason });

  chargingPageStopChargingError = ({ state, errorMessage }) =>
    this.track('查看充電中頁_停止充電錯誤', { 狀態: state, 錯誤訊息: errorMessage });

  // 查看充電中頁-計費達預扣額度停止充電
  chargingPageOverChargePageView = ({ state, stopReason }) =>
    this.track('查看充電中頁-計費達預扣額度_pageview', {
      狀態: state,
      停止原因: stopReason,
    });
  chargingPageOverChargeButtonOnClick = ({ state, stopReason }) =>
    this.track('查看充電中頁-計費達預扣額度_我知道了_點擊', {
      狀態: state,
      停止原因: stopReason,
    });

  // 查看充電中頁-系統異常停止充電
  chargingPageSystemErrorPageView = ({ state, stopReason }) =>
    this.track('查看充電中頁-系統異常_pageview', {
      狀態: state,
      停止原因: stopReason,
    });
  chargingPageSystemErrorButtonOnClick = ({ state, stopReason }) =>
    this.track('查看充電中頁-系統異常_我知道了_點擊', {
      狀態: state,
      停止原因: stopReason,
    });
}

const amplitudeServiceInstance = new amplitudeService();

export default amplitudeServiceInstance;
